import React from 'react';
import { useSelector } from 'react-redux';
import _sortBy from 'lodash/sortBy';

// selectors
import { getSilhouette } from 'cards/selectors/samplesFlow';

// components
import { ptToPx } from 'cards/util';
import { DesignCustomizations } from 'cards/reducers/samplesFlow/types';
import ImageElement from '../../../SamplePreview/ImageElement';
import TextElement from '../../../SamplePreview/TextElement';

import styles from './styles.module.less';

interface PreviewProps {
  customizations: DesignCustomizations;
  page: any;
  width?: number;
}

const Preview = ({ customizations, page, width = 330 }: PreviewProps): JSX.Element | null => {
  const silhouette = useSelector(getSilhouette);

  if (!page) return null;

  const { elements } = page;
  const orderedElements = _sortBy(elements, element => element.layer);

  const { width: widthPt, height: heightPt } = page;
  const templateWidth = ptToPx(widthPt);
  const templateHeight = ptToPx(heightPt);
  const scale = width / Math.max(templateWidth, templateHeight);
  const isRounded = silhouette === 'rounded';

  const { uploadcareFile } = customizations;

  const customImageIndex = orderedElements.findIndex(
    element => element.content_type === 'IMAGE' && element.customizable
  );

  const renderElement = (element: any, i: number): JSX.Element | null => {
    switch (element.content_type) {
      case 'IMAGE': {
        if (customImageIndex === i) {
          return (
            <ImageElement
              key={i}
              element={element}
              pixelCrop={null}
              photo={null}
              uploadcareFile={uploadcareFile}
              isRounded={isRounded}
              border
            />
          );
        }
        // @ts-ignore
        return <ImageElement key={i} element={element} isRounded={isRounded} border />;
      }
      case 'TEXT': {
        return <TextElement key={i} element={element} />;
      }
      default:
        return null;
    }
  };

  return (
    <div style={{ height: templateHeight * scale, width }}>
      <div
        className={styles.preview}
        style={{
          width: templateWidth,
          height: templateHeight,
          marginLeft: (width - templateWidth * scale) / 2,
          transform: `scale(${scale})`,
        }}
      >
        {orderedElements.map(renderElement)}
      </div>
    </div>
  );
};

export default Preview;
